import { BooleanFilterEnum } from '../../../enums/boolean-filter.enum';
import { ApiRequestFilters } from '../../../types/api-request-filters';
import { VehicleCategoryFeatureItemTypeEnum } from '../enums/vehicle-category-feature-item-type.enum';

/**
 * Vehicle category feature items filters
 */
export class VehicleCategoryFeatureItemsFilters extends ApiRequestFilters {
	/**
	 * Types
	 */
	types?: VehicleCategoryFeatureItemTypeEnum[];

	/**
	 * Hidden value
	 */
	hidden?: BooleanFilterEnum;
}
